import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'appFormatSeconds'
})

export class FormatSecondsPipe implements PipeTransform {
    transform(seconds: number) : string {
      const milliseconds = seconds * 1000;
      const dateFormat = seconds >= 60 ? 'mm:ss' : 'ss';

      return moment(milliseconds).utc().format(dateFormat);
    }
}
